exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resource-list .features{font-size:10px;text-align:center}.resource-list .features .fa{font-size:16px;display:block}.resource-list .last-modify{font-size:11px;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/dashboard/list/list.scss
// module id = 568
// module chunks = 0